import React, { useRef, useState, useEffect } from 'react'
import { Accordion, AccordionTab } from "primereact/accordion";
import { Api } from '../../../services/api';
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { EstimatorTemplate } from '../../../services/Template/estimator-template';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import './WARRANTY.css';
import { FaCopy } from 'react-icons/fa';


const WARRANTY = ({ projectId, archiveId }) => {

    const [Title, setTitle] = useState([1, 2, 3, 4, 5]);
    const toast = useRef(null);

    const formik = useFormik({
        initialValues: EstimatorTemplate.getFormWarranty(),
        validate: (data) => {

        },

        // onSubmit: (data) => {
        //     console.log("data");
        //     console.log(data);

        //     data.user_id = localStorage.getItem('user_id');
        //     data.role_id = localStorage.getItem('role_id');

        //     var url = Api.API_BASE_URL + 'job-warranty/save';


        //     fetch(url, {
        //         method: "POST",
        //         headers: {

        //         },
        //         body: JSON.stringify(data),
        //     })
        //         .then((response) => response.json())
        //         .then((Josn) => {
        //             if (Josn.error != '') {
        //                 toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

        //             } else {
        //                 toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });


        //             }

        //         })
        //         .catch((error) => {
        //             console.error("Error:", error);
        //         });


        // }
    });

    const handleAddInputForTitle = () => {
        setTitle([...Title, 1]);

        // warranty
        formik.values.warranty.push({
            followup: '',
            followUpDate: '',
            warranty: '',
            tradePartner: '',
            whoPays: '',
            issue: '',
        });
    };

    const handleDeleteInputForTitle = (index) => {

        formik.values.warranty.splice(index, 1);
        setTitle([...Title, 2]);
        var newArray = [...Title];
        newArray.splice(index, 1);
        setTitle(newArray);
    };

    // ----------------------------------------------------------------------------

    useEffect(() => {
        // setIsLoading(false);
        
            getProjectDetails(archiveId)
       
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);

    const getProjectDetails = async (id) => {
        // fetch.

        var url = Api.API_BASE_URL + 'all-template/get-archive-warranty/' + archiveId + '/' + projectId;

        fetch(url, {
            method: "GET",


        })
            .then((response) => response.json())
            .then((response) => {


                if (response.error == '') {
                    formik.setFieldValue(`warranty`, response.result);


                    formik.setFieldValue(`warranty`, response.result);
                    formik.setFieldValue(`VPComments`, response.result[0].VPComments);

                    var arr = [];
                    response.result.map((e) => {
                        arr.push(1);
                    });
                    setTitle(arr);

                }


            })
            .catch((error) => {
                // setIsLoading(false);
                console.error("Error:", error);
            });
    }






    // ----------------------------------------------------------------------------

    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "18px",
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        // textAlign: 'center',
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'
    };



    //! ----------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, rowCount = 2, formData = '') => (
        <textarea
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            rows={rowCount}
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                console.log(e.target.value)
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
        ></textarea>
    );

    const renderInputArea = (fieldName, placeholder, type = 'text', formData = '') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formData != '' ? formData : formik.values[fieldName]}
            step="any"
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
                console.log(fieldName);
                if (fieldName === 'section_4.0.PlannedCompletionDate') {
                    console.log('Testing');
                    formik.setFieldValue('scheduleConstructionStartDate', e.target.value)

                }
                if (fieldName === 'section_4.12.CurrentForecastCompletionDate') {
                    formik.setFieldValue('scheduleProjectCompletion', e.target.value)
                }


            }} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{
                width: '100%',
                height: '40px',
                boxSizing: 'border-box',
                border: 'none',
                fontSize: '16px',
                textAlign: 'center',
                marginTop: '0px',
            }}
        />
    );

    //! ----------------------------------------------------------------------------


    // ----------------------------------------------------------------------------

    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} className='pm-template-form'>
                {/* <div className='flex d-flex justify-content-end top-button'>
                    
                    <Button className="m-2 mx-4 p-2 px-3 " severity="Secondary" type="button"  title="Copy Client Weekly Update">
                    <strong className="mr-2">Copy weekly update</strong>
                        <FaCopy />
                    </Button>
                    <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center" severity="success" type="submit">
                        <strong className="mr-2">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>
                </div> */}
                <div className="cardd" style={{  border: 'none', }}  >
                    <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6]}>

                        <AccordionTab header="Followup" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px", }}>
                                                Followup
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Follow up Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Warranty/Deficiency
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Trade Partner
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Who Pays?
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Issue
                                            </th>

                                           

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {Title.map((item, index) => (
                                            <tr key={index}>
                                                <td style={cellStyleW} >
                                                    {renderTextArea(`warranty.${index}.followup`, '', 2, formik.values.warranty.followup)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.followUpDate`, '', 'date', formik.values.warranty.followUpDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.warranty`, '', '', formik.values.warranty.warranty)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.tradePartner`, '', '', formik.values.warranty.tradePartner)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.whoPays`, '', 'text', formik.values.warranty.whoPays)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`warranty.${index}.issue`, '', 'text', formik.values.warranty.issue)}
                                                </td>

                                            </tr>
                                        ))}




                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="VP CONSTRUCTION OPS COMMENTS"className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                VP CONSTRUCTION OPS COMMENTS
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td style={cellStyleW}>
                                                {renderTextArea(`VPComments`, '', 6)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                    </Accordion>
                </div>
            </form>
        </>
    )
}

export default WARRANTY